/**
 * Client-side funnel event tracking hook.
 *
 * Uses a stable sessionId from sessionStorage so anonymous events
 * (before login) can be attributed to the same visitor.
 * Calls are fire-and-forget — errors are silently ignored.
 */

import { useCallback } from "react";
import { trpc } from "@/lib/trpc";

export function useFunnelTracking() {
  const trackMutation = trpc.funnel.trackEvent.useMutation();

  const trackEvent = useCallback(
    (eventName: string, metadata?: Record<string, unknown>) => {
      const sessionId = getOrCreateSessionId();
      trackMutation.mutate({ eventName, sessionId, metadata });
    },
    [trackMutation]
  );

  return { trackEvent };
}

function getOrCreateSessionId(): string {
  const key = "funnel_session_id";
  let id = sessionStorage.getItem(key);
  if (!id) {
    id = crypto.randomUUID();
    sessionStorage.setItem(key, id);
  }
  return id;
}
